import React from 'react';
import styles from './styles.module.scss';

const VerticalSeperator = (props: { color?: string; height?: string }) => {
  const { color = 'var(--grayscale-4)', height = '12px' } = props;
  return (
    <div className={styles.verticalSeperator} style={{ backgroundColor: color, height: height }} />
  );
};

export default VerticalSeperator;
